import styled from '@emotion/styled';

const LoadingSpinnerWrapper = styled('section')(({ theme }) => ({
  borderBottom: `2px solid ${theme.palette.background.border}`,
  transition: theme.transitions.create(['border-bottom'])
}));

export default LoadingSpinnerWrapper;
